module.exports = __webpack_public_path__ + "static/media/checkbox_small_partly_checked.c4f7c207.svg";